module.exports = __webpack_public_path__ + "static/media/Ex4.9d372ca9.PNG";